import { render, staticRenderFns } from "./standardFileDetail.vue?vue&type=template&id=52afc9ff&scoped=true&"
import script from "./standardFileDetail.vue?vue&type=script&lang=js&"
export * from "./standardFileDetail.vue?vue&type=script&lang=js&"
import style0 from "./standardFileDetail.vue?vue&type=style&index=0&id=52afc9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afc9ff",
  null
  
)

export default component.exports